import { axiospost, post } from "../api.interceptor";
import { DocumentRequest } from "../interfaces/requests.entities";

const DIGIASSUR_BASE_URL = `${process.env.REACT_APP_DIGIASSUR_BASE_URL}`;

export const chatDocument = async (body: FormData) => {
  const res = await axiospost(DIGIASSUR_BASE_URL + "/api/chat/document", body);
  return await res.data;
};
